import React from 'react';
import PropTypes from 'prop-types';

export default function CopyIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 20" {...rest}>
      <path
        fill={color}
        d="M0,0 L12.7876346,0 L12.7876346,3.18033339 L15.9618515,3.18033339 L16,3.18033339 L16,20 L15.9618515,20 L15.0890405,20 L4.08451862,20 L3.17421689,20 L3.17421689,19.0927766 L3.17421689,17.0870517 L0,17.0870517 L0,16.3657181 L0,16.1791547 L0,0.907896952 L0,0 Z M0.911156787,0.907694898 L0.911156787,16.1796262 L3.17375647,16.1796262 L4.08471594,16.1796262 L11.8768725,16.1796262 L11.8768725,0.907694898 L0.911156787,0.907694898 Z M4.08471594,17.0868496 L4.08471594,19.0925745 L15.0892379,19.0925745 L15.0892379,4.0887018 L12.7878319,4.0887018 L12.7878319,16.3655161 L12.7878319,17.0868496 L4.08471594,17.0868496 Z"
      />
    </svg>
  );
}

CopyIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

CopyIcon.defaultProps = {
  size: 15,
  color: '#000',
};
